import { TriggerActionType } from 'models/automation/Triggers';

export const MESSAGE_LOG_TAB_FILTERS_LOCAL_STORAGE_KEY_PREFIX =
  'message-log-tab-user:';

export const AVAILABLE_FILTER_ACTIONS: TriggerActionType[] = [
  TriggerActionType.DIRECT_MESSAGE,
  TriggerActionType.EMAIL,
  TriggerActionType.SMS,
  TriggerActionType.WHATSAPP,
];
